import { CSSProperties, StyleSheet } from 'aphrodite';
import {
	background,
	brandPrimary,
	brandSecondary,
	inputBorderColor,
	mention,
	mentionDark,
	navigation,
	titles,
} from '../../../../web/styles/colors';
import { CssSelectors, baseStyles } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	adminNameInputs: {
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':last-child'
		),
	},
	autocompleteBox: {
		maxWidth: 210,
		width: '100%',
	},
	buttonContainer: {
		margin: '14px 0 14px 0',
		maxWidth: 435,
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'button'
		),
	},
	chargifyField: {
		marginTop: 40,
	},
	contentContainer: {
		margin: 15,
	},
	dropdownMenu: {
		marginTop: -1,
		minWidth: '100%',
		userSelect: 'none',
		width: '100%',
	},
	fieldContainerHighlight: {
		alignItems: 'center',
		background: mention,
		border: `1px solid ${mentionDark}`,
		borderRadius: 3,
		color: titles,
		display: 'flex',
		fontSize: 14,
		height: 40,
		marginBottom: 20,
		maxWidth: 435,
		padding: '0 10px',
		width: '100%',
	},
	fieldContainerMultiple: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 20,
		maxWidth: 435,
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginRight: 10,
			},
			':first-child'
		),
	},
	fieldContainerSelected: {
		border: `1px solid ${brandPrimary}`,
	},
	fieldContainerStandard: {
		marginBottom: 14,
		maxWidth: 435,
		width: '100%',
		...CssSelectors.allDescendants(
			{
				display: 'inline-block',
				fontSize: 14,
				marginRight: 10,
				textAlign: 'left',
				width: 100,
			},
			'label'
		),
		...CssSelectors.allDescendants(
			{
				color: navigation,
				fontSize: 12,
			},
			'.fieldLabel'
		),
		...CssSelectors.allDescendants(
			{
				color: navigation,
				fontSize: 13,
				marginBottom: 5,
			},
			'.formFieldLabel'
		),
		...CssSelectors.allDescendants(
			{
				color: titles,
				fontSize: 14,
				marginBottom: 5,
			},
			'.fieldValue'
		),
	},
	fieldMultipleColumn: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
	},
	formFieldLabel: {
		color: titles,
		fontSize: 14,
		marginBottom: 10,
	},
	requiredFieldAsterisk: {
		color: 'red',
	},
	fieldContainerCheckbox: {
		marginBottom: 14,
		maxWidth: 435,
		width: '100%',
	},
	customCheckbox: {
		// Remove the global override since we'll use a wrapper span
	},
	checkboxLabel: {
		color: '#000000',
		fontSize: 14,
		marginLeft: 20,
	},
	dropdownSearchBox: {
		':focus': {
			border: `1px solid ${brandSecondary}`,
			outline: 'none',
		},
		border: `1px solid ${inputBorderColor}`,
		borderRadius: 3,
		fontSize: 14,
		marginBottom: 8,
		padding: '8px 12px',
	},
	headerTitle: {
		color: brandPrimary,
		fontSize: 34,
		maxWidth: 1035,
		textAlign: 'center',
		width: '100%',
	},
	rightColumn: {
		flex: 1,
		marginLeft: 50,
	},
	searchBox: {
		':focus-within': {
			border: `1px solid ${brandSecondary}`,
			outline: 'none',
		},
		maxWidth: 210,
		padding: 5,
		paddingLeft: 10,
		width: '100%',
	},
	selectTrigger: {
		...(baseStyles.textField as CSSProperties),
		height: 40,
		minWidth: '100%',
	},
	textBox: {
		':focus': {
			border: `1px solid ${brandSecondary}`,
			outline: 'none',
		},
		backgroundColor: background,
		border: `1px solid ${inputBorderColor}`,
		borderRadius: 3,
		color: titles,
		maxWidth: 418,
		padding: '10px 5px 10px 10px',
		width: '100%',
	},
	textBoxShort: {
		flex: 1,
	},
	twoColumnLayout: {
		display: 'flex',
		justifyContent: 'space-evenly',
	},
});
